"use strict";

/**
 * @author Jey-en  https://github.com/adrs2002
 *
 * this loader repo -> https://github.com/adrs2002/threeXLoader
 *
 * This loader is load model (and animation) from .X file format. (for old DirectX).
 *  ! this version are load from TEXT format .X only ! not a Binary.
 *
 * Support
 *  - mesh
 *  - texture
 *  - normal / uv
 *  - material
 *  - skinning
 *
 *  Not Support
 *  - template
 *  - material(ditail)
 *  - morph
 *  - scene
 */

import * as THREE from 'three';

export default class XLoader {
  // コンストラクタ

  /**
   *
   * @param { THREE.LoadingManager } manager
   * @param { THREE.TextureLoader } texloader
   */
  constructor(manager, texloader) {

    this.debug = false;

    this.manager = (manager !== undefined) ? manager : new THREE.DefaultLoadingManager();
    this.texloader = (texloader !== undefined) ? texloader : new THREE.TextureLoader();

    this.url = "";
    this.baseDir = "";

    this._putMatLength = 0;
    this._nowMat = null;

    //UV割り出し用の一時保管配列
    this._tmpUvArray = [];

    this._facesNormal = [];

    //現在読み出し中のフレームの階層構造。
    this.frameHierarchie = [];
    this.Hierarchies = {};
    this.HieStack = [];
    this._currentObject = {};

    this._data = null;
    this.onLoad = null;

    this.IsUvYReverse = true;

    this.Meshes = [];

    this._currentGeo = null;
  }

  _setArgOption(_arg, _start = 0) {
    if (!_arg) {
      return;
    }
    for (let i = _start; i < _arg.length; i++) {
      switch (i) {
        case 0:
          this.url = _arg[i];
          break;
        case 1:
          this.options = _arg[i];
          break;
      }
    }
    if (this.options === undefined) {
      this.options = {};
    }
  }

  //読み込み開始命令部
  load(_arg, onLoad, onProgress, onError) {

    this._setArgOption(_arg);

    const loader = new THREE.FileLoader(this.manager);
    loader.setResponseType('arraybuffer');

    loader.load(this.url, (response) => {

      this._parse(response, onLoad);

    }, onProgress, onError);

  }

  // DL済みのレスポンスデータから読み込みを行う
  fromResponsedData(_data, _arg, onLoad) {

    this._setArgOption(_arg);
    this._parse(_data, onLoad);

  }

  /**
   * コメントを外した行を取得する
   */
  _readLine(line) {
    let readed = 0;
    while (true) {
      let find = -1;
      find = line.indexOf('//', readed);
      if (find === -1) {
        find = line.indexOf('#', readed);
      }
      if (find > -1 && find < 2) {
        let foundNewLine = -1;
        foundNewLine = line.indexOf("\r\n", readed);
        if (foundNewLine > 0) {
          readed = foundNewLine + 2;
        } else {
          foundNewLine = line.indexOf("\r", readed);
          if (foundNewLine > 0) {
            readed = foundNewLine + 1;
          } else {
            readed = line.indexOf("\n", readed) + 1;
          }
        }
      } else {
        break;
      }
    }
    return line.substr(readed);
  }

  /**
   * コメントを外した行を取得する
   */
  _readLine(line) {
    let readed = 0;
    while (true) {
      let find = -1;
      find = line.indexOf('//', readed);
      if (find === -1) {
        find = line.indexOf('#', readed);
      }
      if (find > -1 && find < 2) {
        let foundNewLine = -1;
        foundNewLine = line.indexOf("\r\n", readed);
        if (foundNewLine > 0) {
          readed = foundNewLine + 2;
        } else {
          foundNewLine = line.indexOf("\r", readed);
          if (foundNewLine > 0) {
            readed = foundNewLine + 1;
          } else {
            readed = line.indexOf("\n", readed) + 1;
          }
        }
      } else {
        break;
      }
    }
    return line.substr(readed);
  }

  _isBinary(binData) {

    const reader = new DataView(binData);
    const face_size = (32 / 8 * 3) + ((32 / 8 * 3) * 3) + (16 / 8);
    const n_faces = reader.getUint32(80, true);
    const expect = 80 + (32 / 8) + (n_faces * face_size);

    if (expect === reader.byteLength) {
      return true;
    }

    // some binary files will have different size from expected,
    // checking characters higher than ASCII to confirm is binary
    const fileLength = reader.byteLength;
    for (let index = 0; index < fileLength; index++) {

      if (reader.getUint8(index, false) > 127) {

        return true;

      }
    }
    return false;
  }

  ensureBinary(buf) {

    if (typeof buf === "string") {

      const array_buffer = new Uint8Array(buf.length);
      for (let i = 0; i < buf.length; i++) {

        array_buffer[i] = buf.charCodeAt(i) & 0xff; // implicitly assumes little-endian

      }

      return array_buffer.buffer || array_buffer;

    } else {

      return buf;

    }
  }

  ensureString(buf) {

    if (typeof buf !== "string") {
      const array_buffer = new Uint8Array(buf);
      let str = '';
      for (let i = 0; i < buf.byteLength; i++) {
        str += String.fromCharCode(array_buffer[i]); // implicitly assumes little-endian
      }

      return str;

      // return THREE.Loader.decodeText( new Uint8Array( buf ) );
    } else {

      return buf;

    }
  }

  //解析を行う前に、バイナリファイルかテキストファイルかを判別する。今はテキストファイルしか対応できていないので・・・
  _parse(data, onLoad) {

    const binData = this.ensureBinary(data);
    this._data = this.ensureString(data);
    this.onLoad = onLoad;
    return this._isBinary(binData) ?
      this._parseBinary(binData) :
      this._parseASCII();

  }

  /*
  バイナリデータだった場合の読み込み。現在は基本的に未対応
  */
  _parseBinary(data) {
    //ねげちぶ！
    return this._parseASCII(String.fromCharCode.apply(null, data));

  }

  _parseASCII() {
    //モデルファイルの元ディレクトリを取得する
    let baseDir = "";
    if (this.url.lastIndexOf("/") > 0) {

      this.baseDir = this.url.substr(0, this.url.lastIndexOf("/") + 1);

    }

    // 返ってきたデータを行ごとに分解

    // 階層構造分解
    let added = 0;
    let endRead = 16; // 先頭16文字は固定
    this.Hierarchies.children = [];
    this._hierarchieParse(this.Hierarchies, endRead);
    this._changeRoot();
    this._currentObject = this.Hierarchies.children.shift();
    this.mainloop();

  }

  _hierarchieParse(_parent, _end) {
    let endRead = _end;
    while (true) {
      const find1 = this._data.indexOf('{', endRead) + 1;
      const findEnd = this._data.indexOf('}', endRead);
      const findNext = this._data.indexOf('{', find1) + 1;
      if (find1 > 0 && findEnd > find1) {
        const _currentObject = {};
        _currentObject.children = [];
        const nameData = this._readLine(this._data.substr(endRead, find1 - endRead - 1))
          .trim();

        const word = nameData.split(/ /g);
        if (word.length > 0) {
          _currentObject.type = word[0];
          if (word.length >= 2) {
            _currentObject.name = word[1];
          } else {
            _currentObject.name = word[0] + this.Hierarchies.children.length;
          }
        } else {
          _currentObject.name = nameData;
          _currentObject.type = "";
        }

        if (_currentObject.type === "Animation") {
          _currentObject.data = this._data.substr(findNext, findEnd - findNext)
            .trim();
          const refs = this._hierarchieParse(_currentObject, findEnd + 1);
          endRead = refs.end;
          _currentObject.children = refs.parent.children;
        } else {
          const DataEnder = this._data.lastIndexOf(';', findNext > 0 ? Math.min(findNext, findEnd) :
            findEnd);
          _currentObject.data = this._data.substr(find1, DataEnder - find1)
            .trim();
          if (findNext <= 0 || findEnd < findNext) {
            // 子階層なし。クローズ
            endRead = findEnd + 1;
          } else {
            // 子階層あり
            const nextStart = Math.max(DataEnder + 1, find1);
            const refs = this._hierarchieParse(_currentObject, nextStart);
            endRead = refs.end;
            _currentObject.children = refs.parent.children;
          }
        }
        _currentObject.parent = _parent;
        if (_currentObject.type != "template") {
          _parent.children.push(_currentObject);
        }
      } else {
        endRead = find1 === -1 ? this._data.length : findEnd + 1;
        break;
      }
    }

    return {
      parent: _parent,
      end: endRead
    };
  }

  mainloop() {

    this.mainProc();
    if (this._currentObject.parent || this._currentObject.children.length > 0 || !this._currentObject.worked) {
      // this._currentObject = this._currentObject.parent;
      setTimeout(() => {
        this.mainloop();
      }, 1);
    } else {
      // this._readFinalize();
      setTimeout(() => {
        this.onLoad({
          models: this.Meshes
        })
      }, 1);
    }
  }

  mainProc() {
    let breakFlag = false;
    while (true) {
      if (!this._currentObject.worked) {
        switch (this._currentObject.type) {
          case "template":
            break;

          case "Mesh":
            this._changeRoot();
            this._currentGeo = {};
            this._currentGeo.name = this._currentObject.name.trim();
            this._currentGeo.parentName = this._getParentName(this._currentObject)
              .trim();
            this._currentGeo.Geometry = new THREE.Geometry();
            this._currentGeo.Materials = [];
            this._currentGeo.normalVectors = [];
            this._currentGeo.vertexColors = [];
            this._readVertexDatas();
            breakFlag = true;
            break;

          case "MeshVertexColors":
            this._readVertexDatas();
            break;

          case "MeshNormals":
            this._readVertexDatas();
            break;

          case "MeshTextureCoords":
            this._setMeshTextureCoords();
            break;

          case "VertexDuplicationIndices":
            break;

          case "MeshMaterialList":
            this._setMeshMaterialList();
            break;

          case "Material":
            this._setMaterial();
            break;
        }
        this._currentObject.worked = true;
      }

      if (this._currentObject.children.length > 0) {
        this._currentObject = this._currentObject.children.shift();
        if (this.debug) {
          console.log('processing ' + this._currentObject.name);
        }
        if (breakFlag) break;
      } else {
        // ルート＝親が１つだけの場合
        if (this._currentObject.worked) {
          if (this._currentObject.type === "Mesh") {
            // this._changeRoot();
          }

          if (this._currentObject.parent && !this._currentObject.parent.parent) {
            this._changeRoot();
          }
        }

        if (this._currentObject.parent) {
          this._currentObject = this._currentObject.parent;
        } else {
          breakFlag = true;
        }
        if (breakFlag) break;
      }
    }
    return;
  }

  _changeRoot() {

    if (this._currentGeo != null && this._currentGeo.name) {
      this._makeOutputGeometry();
    }
    this._currentGeo = {};
  }

  _getParentName(_obj) {
    if (_obj.parent) {
      if (_obj.parent.name) {
        return _obj.parent.name;
      } else {
        return this._getParentName(_obj.parent);
      }
    } else {
      return "";
    }
  }

  _readVertexDatas() {
    // 1行目は総頂点数。
    let endRead = 0;
    let totalV = 0;
    let totalFace = 0;
    let mode = 0;
    let mode_local = 0
    let maxLength = 0;
    let nowReadedLine = 0;
    while (true) {
      let changeMode = false;
      if (mode_local === 0) {
        const refO = this._readInt1(endRead);
        totalV = refO.refI;
        endRead = refO.endRead;
        mode_local = 1;
        nowReadedLine = 0;
        maxLength = this._currentObject.data.indexOf(';;', endRead) + 1;
        if (maxLength <= 0) {
          maxLength = this._currentObject.data.length
        }
      } else {
        let find = 0;
        switch (mode) {
          case 0:
            find = this._currentObject.data.indexOf(',', endRead) + 1;
            break;
          case 1:
            find = this._currentObject.data.indexOf(';,', endRead) + 1;
            break;
        }

        if (find === 0 || find > maxLength) {
          find = maxLength;
          mode_local = 0;
          changeMode = true;
        }

        switch (this._currentObject.type) {
          case "Mesh":
            switch (mode) {
              case 0:
                this._readVertex1(this._currentObject.data.substr(endRead, find - endRead));
                break;
              case 1:
                this._readFace1(this._currentObject.data.substr(endRead, find - endRead));
                break;
            }
            break;

          case "MeshNormals":
            switch (mode) {
              case 0:
                this._readNormalVector1(this._currentObject.data.substr(endRead, find - endRead));
                break;
              case 1:
                this._readNormalFace1(this._currentObject.data.substr(endRead, find - endRead),
                  nowReadedLine);
                break;
            }
            break;

          case "MeshVertexColors":
            switch (mode) {
              case 0:
                this._readVertexColor1(this._currentObject.data.substr(endRead, find - endRead));
                break;
              case 1:
                this._readVertexFace1(this._currentObject.data.substr(endRead, find - endRead),
                  nowReadedLine);
                break;
            }
            break;
        }
        endRead = find + 1;
        nowReadedLine++;
        if (changeMode) {
          mode++;
        }
      }
      if (endRead >= this._currentObject.data.length) {
        break;
      }
    }
  }

  _readInt1(start) {
    const find = this._currentObject.data.indexOf(';', start);
    return {
      refI: parseInt(this._currentObject.data.substr(start, find - start)),
      endRead: find + 1
    };
  }

  _readVertex1(line) {
    //頂点が確定
    const data = this._readLine(line.trim())
      .substr(0, line.length - 2)
      .split(";");
    this._currentGeo.Geometry.vertices.push(new THREE.Vector3(parseFloat(data[0]), parseFloat(data[1]), parseFloat(data[2])));
    //頂点を作りながら、Skin用構造も作成してしまおう
    this._currentGeo.Geometry.skinIndices.push(new THREE.Vector4(0, 0, 0, 0));
    this._currentGeo.Geometry.skinWeights.push(new THREE.Vector4(1, 0, 0, 0));
  }

  _readFace1(line) {
    // 面に属する頂点数,頂点の配列内index という形で入っている
    const data = this._readLine(line.trim())
      .substr(2, line.length - 4)
      .split(",");
    this._currentGeo.Geometry.faces.push(new THREE.Face3(parseInt(data[0], 10), parseInt(data[1],
        10), parseInt(data[3], 10), new THREE.Vector3(1, 1, 1)
      .normalize()));
    this._currentGeo.Geometry.faces.push(new THREE.Face3(parseInt(data[1], 10), parseInt(data[2],
        10), parseInt(data[3], 10), new THREE.Vector3(1, 1, 1)
      .normalize()));
  }

  _readNormalVector1(line) {
    const data = this._readLine(line.trim())
      .substr(0, line.length - 2)
      .split(";");
    this._currentGeo.normalVectors.push(new THREE.Vector3(parseFloat(data[0]), parseFloat(
      data[1]), parseFloat(data[2])));
  }

  _readNormalFace1(line, nowReaded) {

    const data = this._readLine(line.trim())
      .substr(2, line.length - 4)
      .split(",");

    let nowID = parseInt(data[0], 10);
    const v1 = this._currentGeo.normalVectors[nowID];
    nowID = parseInt(data[1], 10);
    const v2 = this._currentGeo.normalVectors[nowID];
    nowID = parseInt(data[2], 10);
    const v3 = this._currentGeo.normalVectors[nowID];

    this._currentGeo.Geometry.faces[nowReaded].vertexNormals = [v1, v2, v3];

  }

  _readVertexColor1(line) {
    const data = this._readLine(line.trim())
      .substr(0, line.length - 2)
      .split(";");

    var color = new THREE.Color(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
    this._currentGeo.vertexColors.push(color);

    for (var i = 0; i < this._currentGeo.Geometry.faces.length; i++) {
      if (this._currentGeo.Geometry.faces[i].a == data[0])
        this._currentGeo.Geometry.faces[i].vertexColors[0] = color;

      if (this._currentGeo.Geometry.faces[i].b == data[0])
        this._currentGeo.Geometry.faces[i].vertexColors[1] = color;

      if (this._currentGeo.Geometry.faces[i].c == data[0])
        this._currentGeo.Geometry.faces[i].vertexColors[2] = color;
    }
  }

  _readVertexFace1(line, nowReaded) {

    const data = this._readLine(line.trim())
      .substr(2, line.length - 4)
      .split(",");

    let nowID = parseInt(data[0], 10);
    const v1 = this._currentGeo.vertexColors[nowID];
    nowID = parseInt(data[1], 10);
    const v2 = this._currentGeo.vertexColors[nowID];
    nowID = parseInt(data[2], 10);
    const v3 = this._currentGeo.vertexColors[nowID];

    this._currentGeo.Geometry.faces[nowReaded].vertexColors = [v1, v2, v3];
  }

  _setMeshNormals() {
    let endRead = 0;
    let totalV = 0;
    let totalFace = 0;
    let mode = 0;
    let mode_local = 0
    while (true) {
      switch (mode) {
        case 0: //vertex
          if (mode_local === 0) {
            const refO = this._readInt1(0);
            totalV = refO.refI;
            endRead = refO.endRead;
            mode_local = 1;
          } else {
            let find = this._currentObject.data.indexOf(',', endRead) + 1;
            if (find === -1) {
              find = this._currentObject.data.indexOf(';;', endRead) + 1;
              mode = 2;
              mode_local = 0;
            }
            const line = this._currentObject.data.substr(endRead, find - endRead);
            const data = this._readLine(line.trim())
              .split(";");
            this._currentGeo.normalVectors.push([parseFloat(data[0]), parseFloat(data[1]),
              parseFloat(data[2])
            ]);
            endRead = find + 1;
          }
          break;
      }
      if (endRead >= this._currentObject.data.length) {
        break;
      }
    }
  }

  _setMeshTextureCoords() {
    this._tmpUvArray = [];
    this._currentGeo.Geometry.faceVertexUvs = [];
    this._currentGeo.Geometry.faceVertexUvs.push([]);

    let endRead = 0;
    let totalV = 0;
    let totalFace = 0;
    let mode = 0;
    let mode_local = 0
    while (true) {
      switch (mode) {
        case 0: //vertex
          if (mode_local === 0) {
            const refO = this._readInt1(0);
            totalV = refO.refI;
            endRead = refO.endRead;
            mode_local = 1;
          } else {
            let find = this._currentObject.data.indexOf(',', endRead) + 1;
            if (find === 0) {
              find = this._currentObject.data.length;
              mode = 2;
              mode_local = 0;
            }
            const line = this._currentObject.data.substr(endRead, find - endRead);
            const data = this._readLine(line.trim())
              .split(";");
            if (this.IsUvYReverse) {
              this._tmpUvArray.push(new THREE.Vector2(parseFloat(data[0]), 1 - parseFloat(data[
                1])));
            } else {
              this._tmpUvArray.push(new THREE.Vector2(parseFloat(data[0]), parseFloat(data[1])));
            }
            endRead = find + 1;
          }
          break;
      }
      if (endRead >= this._currentObject.data.length) {
        break;
      }
    }
    //UV読み込み完了。メッシュにUVを割り当てる
    this._currentGeo.Geometry.faceVertexUvs[0] = [];
    for (var m = 0; m < this._currentGeo.Geometry.faces.length; m++) {
      this._currentGeo.Geometry.faceVertexUvs[0][m] = [];
      this._currentGeo.Geometry.faceVertexUvs[0][m].push(this._tmpUvArray[this._currentGeo.Geometry
        .faces[m].a]);
      this._currentGeo.Geometry.faceVertexUvs[0][m].push(this._tmpUvArray[this._currentGeo.Geometry
        .faces[m].b]);
      this._currentGeo.Geometry.faceVertexUvs[0][m].push(this._tmpUvArray[this._currentGeo.Geometry
        .faces[m].c]);

    }
    this._currentGeo.Geometry.uvsNeedUpdate = true;
  }

  _setMeshMaterialList() {
    let endRead = 0;
    let mode = 0;
    let mode_local = 0;
    let readCount = 0;
    while (true) {
      if (mode_local < 2) {
        const refO = this._readInt1(endRead);
        endRead = refO.endRead;
        mode_local++;
        readCount = 0;
      } else {
        let find = this._currentObject.data.indexOf(';', endRead);
        if (find === -1) {
          find = this._currentObject.data.length;
          mode = 3;
          mode_local = 0;
        }
        const line = this._currentObject.data.substr(endRead, find - endRead);
        const data = this._readLine(line.trim())
          .split(",");
        for (let i = 0; i < data.length; i++) {
          this._currentGeo.Geometry.faces[i].materialIndex = parseInt(data[i]);
        }
        endRead = this._currentObject.data.length;
      }
      if (endRead >= this._currentObject.data.length || mode >= 3) {
        break;
      }
    }
  }

  _setMaterial() {
    const _nowMat = new THREE.MeshPhongMaterial({
      color: Math.random() * 0xffffff
    });

    _nowMat.side = THREE.FrontSide;
    _nowMat.name = this._currentObject.name;

    let endRead = 0;
    // １つめの[;;]まで＝Diffuse
    let find = this._currentObject.data.indexOf(';;', endRead);
    let line = this._currentObject.data.substr(endRead, find - endRead);
    const data = this._readLine(line.trim())
      .split(";");
    _nowMat.color.r = parseFloat(data[0]);
    _nowMat.color.g = parseFloat(data[1]);
    _nowMat.color.b = parseFloat(data[2]);

    // 次の [;]まで＝反射率
    endRead = find + 2;
    find = this._currentObject.data.indexOf(';', endRead);
    line = this._currentObject.data.substr(endRead, find - endRead);
    _nowMat.shininess = parseFloat(this._readLine(line));

    // 次の[;;]まで＝反射光？
    endRead = find + 1;
    find = this._currentObject.data.indexOf(';;', endRead);
    line = this._currentObject.data.substr(endRead, find - endRead);
    const data2 = this._readLine(line.trim())
      .split(";");
    _nowMat.specular.r = parseFloat(data2[0]);
    _nowMat.specular.g = parseFloat(data2[1]);
    _nowMat.specular.b = parseFloat(data2[2]);

    // 次の [;]まで＝発光色?
    endRead = find + 2;
    find = this._currentObject.data.indexOf(';;', endRead);
    if (find === -1) {
      find = this._currentObject.data.length;
    }
    line = this._currentObject.data.substr(endRead, find - endRead);
    const data3 = this._readLine(line.trim())
      .split(";");
    _nowMat.emissive.r = parseFloat(data3[0]);
    _nowMat.emissive.g = parseFloat(data3[1]);
    _nowMat.emissive.b = parseFloat(data3[2]);

    // 子階層処理
    let localObject = null;
    while (true) {
      if (this._currentObject.children.length > 0) {
        localObject = this._currentObject.children.shift();
        if (this.debug) {
          console.log('processing ' + localObject.name);
        }
        const fileName = localObject.data.substr(1, localObject.data.length - 2);
        switch (localObject.type) {
          case "TextureFilename":
            _nowMat.map = this.texloader.load(this.baseDir + fileName);
            break;
          case "BumpMapFilename":
            _nowMat.bumpMap = this.texloader.load(this.baseDir + fileName);
            _nowMat.bumpScale = 0.05;
            break;
          case "NormalMapFilename":
            _nowMat.normalMap = this.texloader.load(this.baseDir + fileName);
            _nowMat.normalScale = new THREE.Vector2(2, 2);
            break;
          case "EmissiveMapFilename":
            _nowMat.emissiveMap = this.texloader.load(this.baseDir + fileName);
            break;
          case "LightMapFilename":
            _nowMat.lightMap = this.texloader.load(this.baseDir + fileName);
            break;

            // _nowMat.envMap = this.texloader.load(this.baseDir + data);
        }
      } else {
        break;
      }
    }

    this._currentGeo.Materials.push(_nowMat);
  }

  _makeOutputGeometry() {

    //１つのmesh終了
    this._currentGeo.Geometry.computeBoundingBox();
    this._currentGeo.Geometry.computeBoundingSphere();

    this._currentGeo.Geometry.verticesNeedUpdate = true;
    this._currentGeo.Geometry.normalsNeedUpdate = true;
    this._currentGeo.Geometry.colorsNeedUpdate = true;
    this._currentGeo.Geometry.uvsNeedUpdate = true;
    this._currentGeo.Geometry.groupsNeedUpdate = true;

    //ボーンの階層構造を作成する

    let mesh = null;

    const bufferGeometry = new THREE.BufferGeometry()
      .fromGeometry(this._currentGeo.Geometry);
    mesh = new THREE.Mesh(bufferGeometry, this._currentGeo.Materials.length === 1 ? this._currentGeo.Materials[0] : this._currentGeo.Materials);

    mesh.name = this._currentGeo.name;

    this.Meshes.push(mesh);
  }

  _readFinalize() {
    //アニメーション情報、ボーン構造などを再構築
    //一部ソフトウェアからの出力用（DirectXとOpenGLのZ座標系の違い）に、鏡面処理を行う
    if (this.options.zflag) {
      for (let i = 0; i < this.Meshes.length; i++) {
        this.Meshes[i].scale.set(-1, 1, 1);
      }
    }
  }

  ///

  /////////////////////////////////
  _ParseMatrixData(targetMatrix, data) {

    targetMatrix.set(
      parseFloat(data[0]), parseFloat(data[4]), parseFloat(data[8]), parseFloat(data[12]),
      parseFloat(data[1]), parseFloat(data[5]), parseFloat(data[9]), parseFloat(data[13]),
      parseFloat(data[2]), parseFloat(data[6]), parseFloat(data[10]), parseFloat(data[14]),
      parseFloat(data[3]), parseFloat(data[7]), parseFloat(data[11]), parseFloat(data[15]));

  }

};



//////////////////
// WEBPACK FOOTER
// ./src/misc/external/XFileLoader.js
// module id = crnt
// module chunks = 1